/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partnersremovetitle2Inputs */

const en_partnersremovetitle2 = /** @type {(inputs: Partnersremovetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name} from this partner?`)
};

const de_partnersremovetitle2 = /** @type {(inputs: Partnersremovetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} von diesem Partner lösen?`)
};

/**
* | output |
* | --- |
* | "Remove {name} from this partner?" |
*
* @param {Partnersremovetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersremovetitle2 = /** @type {((inputs: Partnersremovetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersremovetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersremovetitle2(inputs)
	return de_partnersremovetitle2(inputs)
});
export { partnersremovetitle2 as "partnersRemoveTitle" }